import React from "react";
import { X } from "lucide-react";

const VideoDemoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn-modern" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="video-wrapper-inner">
          <iframe
            className="demo-video-player"
            src="https://www.youtube.com/embed/8T0TDnLZqig?autoplay=1"
            title="Med-CO Demo Video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoDemoModal;
